import React, {PropsWithChildren, ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

interface CustomStampInterface {
	textPosY: number;
}

export class CustomStamp extends PortalPureComponent<PropsWithChildren<AnnotationProperties>, CustomStampInterface> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let fontSize: number = FunctionHelper.applyValue(this.props.fontSize, 40);

		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox={"0 0 300 100"}>
				<g style={{
					opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
					transformOrigin: "50% 50%"
				}}>
					<rect x={1} y={1} rx={5} ry={5} width={298} height={98} style={{
						strokeWidth: 1,
						fill: this.props.color,
						stroke: this.props.borderColor
					}}/>
					{FunctionHelper.exists(this.props.onMoveStart) &&
						<rect x={1} y={1} rx={5} ry={5} width={298} height={98} className="movearea"
                              onClick={this.props.onClick} onContextMenu={this.props.onContextMenu}
							  onPointerDown={this.props.onMoveStart}/>
					}
					<text x={"50%"} y={"50%"} dominantBaseline={"central"}
						  style={{
							  fontFamily: "sans-serif",
							  fontWeight: "bold",
							  fontStyle: "italic",
							  textAnchor: "middle",
							  textTransform: "uppercase",
							  fill: this.props.fontColor,
							  fontSize: fontSize,
							  fontSizeAdjust: "size"
						  }}>
						{this.props.children}
					</text>
				</g>
			</svg>
		);
	}
}